module.exports = __webpack_public_path__ + "media/images/niq-arrow-right-5addd250d350cbfd8f77277ccc4f6e76.svg";